import styled from 'styled-components';
import Box from '@mui/material/Box'; 
// Define a styled Box component
export const StatusBoxWrapper = styled(Box)`
margin: 30px 0;
.statusboxContainer{
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 19px;
    
    .MuiInputBase-input{
      cursor: pointer;
    }
    .wrap{
      cursor: pointer;
    }

    .inputBox{
        width: 100%;
        cursor: pointer;
    }
    .boxRight{
        display: flex;
        align-items: center;
        p{    font-family: 'Noto Sans', sans-serif;
            font-size: 18px;
            color: #1B4A83;
            margin-left: 9px;
        
                  @media screen and (min-device-width: 1099px) and (max-device-width: 1380px) { 
      font-size: 18px;

      }
                                    @media screen and (min-device-width: 768px) and (max-device-width: 1138px) { 
   font-size: 18px;

     }
        }
    }
    .boxLeft{
        display: flex;
        width: 100%;
        justify-content: right;

        span{
           color:  #2A2725;
           font-weight: 700;

                      @media screen and (min-device-width: 1099px) and (max-device-width: 1380px) { 
     font-size: 18px;

     }
                              @media screen and (min-device-width: 768px) and (max-device-width: 1138px) { 
   font-size: 13px;

     }

        }
    }
    .inputborder0 {
        border: 1px solid #1B4A83;
        border-radius: 5px;
        cursor: pointer;
      }
  
      .inputborder1 {
        border: 1px solid #239155;
        border-radius: 5px;
        cursor: pointer;
      }
  
      .inputborder2 {
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder3 {
        border: 1px solid #8A9123;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder4 {
        border: 1px solid #00AF97;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder5 {
        border: 1px solid #91238D;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder6 {
        border: 1px solid #C81E1E;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder7 {
        border: 1px solid #E27900;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder8 {
        border: 1px solid #239155;
        border-radius: 5px;
        cursor: pointer;
      }
  
      .inputborder9 {
        border: 1px solid #000000;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder10 {
        border: 1px solid #8A9123;
        border-radius: 5px;
        cursor: pointer;
      }
      .inputborder11 {
        border: 1px solid #8A9123;
        border-radius: 5px;
        cursor: pointer;
      }
      
      .highlighted0 {
        border: 3px solid #1B4A83; 
        border-radius:5px;
      }
      .highlighted0 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted1 {
        border: 3px solid #239155; 
        border-radius:5px;
      }
      .highlighted1 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted2 {
        border: 3px solid #000000; 
        border-radius:5px;
      }
      .highlighted2 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted3 {
        border: 3px solid #8A9123; 
        border-radius:5px;
      }
      .highlighted3 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted4 {
        border: 3px solid #00AF97; 
        border-radius:5px;
      }
      .highlighted4 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted5 {
        border: 3px solid #91238D; 
        border-radius:5px;
      }
      .highlighted5 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted6 {
        border: 3px solid #C81E1E; 
        border-radius:5px;
      }
      .highlighted6 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted7 {
        border: 3px solid #E27900; 
        border-radius:5px;
        }
        .highlighted7 .Mui-focused .MuiOutlinedInput-notchedOutline {
          border: none;
        }
      .highlighted8 {
        border: 3px solid #239155; 
        border-radius:5px;
      }
      .highlighted8 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted9 {
        border: 3px solid #000000; 
        border-radius:5px;
      }
      .highlighted9 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted10 {
        border: 3px solid #8A9123; 
        border-radius:5px;
      }
      .highlighted10 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .highlighted11 {
        border: 3px solid #8A9123; 
        border-radius:5px;
      }
      .highlighted11 .Mui-focused .MuiOutlinedInput-notchedOutline {
        border: none;
      }
     
    .css-1o9s3wi-MuiInputBase-input-MuiOutlinedInput-input{
        width: 0%;
    }
    .css-1u3bzj6-MuiFormControl-root-MuiTextField-root{
        width: 23%;
        margin: 10px 10px;
                         @media screen and (min-device-width: 768px) and (max-device-width: 1138px) { 
    width: 40%;

     }
     @media screen and (max-width: 769px) {
   width: 100%;
}
    }
    .css-1q6at85-MuiInputBase-root-MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{
        border:none;
    }
}
};



`;
